module.exports = __webpack_public_path__ + "static/img/14000548.893c94e6.png";